import { useState, useEffect } from 'react';
import useAxiosPrivate from '../../auth_services/useAxiosPrivate';
import { useNavigate, useOutletContext } from 'react-router-dom';
import ImgViewer from 'react-viewer';
//material
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';
//icons-material
import EditIcon from '@mui/icons-material/Edit';
import MoreVert from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import Nodata from '../../components/nodata';
import DataTable from '../../components/DataTable';
import AlertPopup from '../../components/modal/AlertPopup';
import '../../css/style.css';
import useAuth from '../../auth_services/useAuth';
import { thana_api_ip } from '../../api/axios';
import PageAccessDenied from "../PageAccessDenied";
import ModalTemplate from '../../components/modal/ModalTemplate';

import MerchantPaymentinfoForm from './MerchantPaymentinfoForm';

import logo192 from "../../picture/logo/logo192.png";

const MerchantPaymentinfo = (props) => {
    const { setOutletContext } = useOutletContext();        // setOutletContext for set attribute value from route children element
    const [loading, setLoading] = useState(true);
    const [nodata, setNodata] = useState();                 // Set val for check null data or no data and show alert no data

    // Call navigate
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();

    // Set val
    const [status, setStatus] = useState();
    const [loadVal, setLoadVal] = useState([]);
    const [editval, setEditval] = useState([]);
    const [alertPopup, setAlertPopup] = useState({ open: false });      // Set val modal alert popup

    // Image path
    let imgPath = thana_api_ip() + "/merchant_info/image/";

    // set view large image
    const [visible, setVisible] = useState(false);                  // Open View image
    const [menuImageViewer, setMenuImageViewer] = useState([]);     // Set image to view

    // Call edit form
    const [openModal, SetOpenModal] = useState(false);                  // Set val modal edit
    const EditForm = () => {
        SetOpenModal(true);     // Open add & edit modal
        setAnchorEl(null);      // Close manage menu  
    }
    const closeModal = () => {
        SetOpenModal(false);
    }

    // Menu
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        document.title = props.documentTitle;   // set Document title
        setOutletContext(props);                // set attribute from route children element
        getMerchant();
    }, []);

    // Set for show or hid when have data
    const [dataTatleShow, setDataTatleShow] = useState('none');

    const getMerchant = async (props) => {
        try {
            const response = await axiosPrivate.get('merchant_paymentinfo');
            if (Object.keys(response.data).length > 0) {
                setDataTatleShow('show');
            }

            setLoadVal(response.data);
            setLoading(false);
            setNodata(Object.keys(response.data).length);
            //setPagination(Pagiantion(Object.keys(response.data).length));
        } catch (error) {
            navigate("/login");
        }
    }

    // Delete Terminal info
    const Delete = async () => {
        // Close manage menu 
        setAnchorEl(null);

        // Alert Popup Delete confirm
        setAlertPopup({
            open: true,
            status: 'error',
            message: 'ເຈົ້າເເນ່ໃຈທີ່ຈະລຶບເເທ້ບໍ່',
            btn: {
                btnAction1: {
                    status: true,
                    txt: 'ເເນ່ໃຈ',
                    func: async () => {
                        try {
                            // Check user id
                            if (!editval.mcid) {
                                setAlertPopup({
                                    open: true,
                                    status: 'warning',
                                    message: 'ລຶບຂໍ້ມູນບໍ່ສໍາເລັດ'
                                });
                                return false;
                            }

                            // call api
                            const response = await axiosPrivate.delete('merchant_paymentinfo/delete/' + editval.iid + '/' + editval.mcid + '/' + useAuth.userName());

                            // Set new value to show
                            setLoadVal(response.data);

                            // Alert success popup
                            setAlertPopup({
                                open: true,
                                status: 'primary',
                                message: 'ລຶບຂໍ້ມູນສໍາເລັດ',
                            });

                        } catch (error) {
                            // Alert error popup
                            setAlertPopup({
                                open: true,
                                status: 'warning',
                                message: error.response.data,
                            });
                        }
                    }
                },
                btnCancel: {
                    status: true,
                    txt: 'ຍົກເລີກ',
                    func: () => {
                        setAlertPopup({ open: false });
                    }
                }
            }
        });
    }

    const SettingMenu = (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            transformOrigin={{ horizontal: 'left', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        >
            <MenuItem onClick={EditForm}>
                <ListItemIcon>
                    <EditIcon />
                </ListItemIcon>
                <ListItemText>
                    ເເກ້ໄຂຂໍ້ມູນ
                </ListItemText>
            </MenuItem>
            <MenuItem onClick={Delete}>
                <ListItemIcon>
                    <DeleteIcon />
                </ListItemIcon>
                <ListItemText>
                    ລຶບຂໍ້ມູນ
                </ListItemText>
            </MenuItem>
        </Menu>
    );

    // Datatable column
    const columns = [
        { name: "payment_provider_id", options: { display: false } },
        { name: "provider", options: { display: false } },
        { name: "merchant_name", options: { display: false } },
        { name: "account", options: { display: false } },
        { name: "id", options: { display: false } },
        { name: "mcid", options: { display: false } },
        { name: "mcc", options: { display: false } },
        { name: "mc_eng", options: { display: false } },
        { name: "shop_code", options: { display: false } },
        { name: "qr_type", options: { display: false } },
        { name: "username", options: { display: false } },
        { name: "password", options: { display: false } },
        {
            name: "", label: "", options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div style={{ width: '30px' }}>
                            <Tooltip title='ປຸ່ມຄໍາສັ່ງ'>
                                <IconButton onClick={handleClick}>
                                    <MoreVert />
                                </IconButton>
                            </Tooltip>
                        </div>
                    )
                }
            }
        },
        {
            name: "mcid", label: 'mcid', options: {
                setCellProps: () => ({ style: { minWidth: "80px" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box sx={{ color: 'text.fixed', cursor: 'pointer' }}>{value}</Box>
                    )
                }
            }
        },
        {
            name: "merchant_name", label: 'Merchant_name', options: {
                setCellProps: () => ({ style: { minWidth: "200px" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box sx={{ color: 'text.fixed', cursor: 'pointer' }} >
                            {value}
                        </Box>
                    )
                }
            }
        },
        {
            name: "mc_eng", label: 'mc_eng', options: {
                setCellProps: () => ({ style: { minWidth: "200px" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box sx={{ color: 'text.fixed', cursor: 'pointer' }} >
                            {value}
                        </Box>
                    )
                }
            }
        },
        {
            name: "provider", label: 'Provider', options: {
                setCellProps: () => ({ style: { minWidth: '70px', width: "70px" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box sx={{ color: 'text.fixed' }}>
                            <Box>{value}</Box>
                        </Box>
                    )
                }
            }
        },
        {
            name: "mcc", label: 'Mcc', options: {
                setCellProps: () => ({ style: { minwidth: "70px", width: '70px' } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box sx={{ color: 'text.fixed' }}>{value}</Box>
                    )
                }
            }
        },
        {
            name: "shop_code", label: 'Shop_code', options: {
                setCellProps: () => ({ style: { minwidth: "80px", width: '80px' } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box sx={{ color: 'text.fixed' }}>{value}</Box>
                    )
                }
            }
        },
        {
            name: "username", label: 'User', options: {
                setCellProps: () => ({ style: { minWidth: '70px', width: "70px" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box sx={{ color: 'text.fixed' }}>
                            <Box>{value}</Box>
                        </Box>
                    )
                }
            }
        },
        {
            name: "password", label: 'Password', options: {
                setCellProps: () => ({ style: { minWidth: '70px', width: "70px" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box sx={{ color: 'text.fixed' }}>
                            <Box>{value}</Box>
                        </Box>
                    )
                }
            }
        },
        {
            name: "qr_type", label: 'QR type', options: {
                setCellProps: () => ({ style: { minwidth: "90px", width: '90px' } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box sx={{ color: 'text.fixed' }}>{value}</Box>
                    )
                }
            }
        },
        {
            name: "status", label: 'ສະຖານະ', options: {
                setCellProps: () => ({ style: { minWidth: '80px', width: "70px" } }),
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <Box sx={{ fontWeight: '600', color: 'text.fixed' }}>
                            <Chip size="small" label={value} color={value == 'active' ? 'primary' : value == 'lock' ? 'warning' : 'error'} />
                        </Box>
                    )
                }
            }
        },
    ];

    const options = {
        filter: false,
        search: true,
        searchOpen: false,
        viewColumns: false,
        print: false,
        download: true,
        selectableRows: 'none', // <===== will turn off checkboxes in rows
        responsive: 'standard',
        onRowClick: (e) => {
            setStatus('edit');
            setEditval({
                iid: e[0],
                provider: e[1],
                merchant_name: e[2],
                account: e[3],
                id: e[4],
                mcid: e[5],
                mcc: e[6],
                mc_eng: e[7],
                shop_code: e[8],
                qr_type: e[9],
                username: e[10],
                password: e[11],
            });
        }
    };

    // Check page access
    if (
        useAuth.checkRole() == false &&
        !useAuth.checkPermission('merchant', 'status_update') &&
        !useAuth.checkPermission('merchant', 'pkunlimit_update') &&
        !useAuth.checkPermission('merchant', 'pk_upadte') &&
        !useAuth.checkPermission('merchant', 'edit')
    ) {
        return (<PageAccessDenied />)
    }

    return (
        <>
            <Box className='mainPageBodyContainer'>
                <Grid container spacing={2}>
                    {/** Page Title name */}
                    <Grid size={{ xs: 6, md: 6 }}>
                        <Box className='pageTitle'>
                            {props.pageTitle}
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 6, md: 6 }} sx={{ textAlign: 'right' }}>
                        <Box className='pageTitle'>
                            <Button
                                size="small"
                                variant="contained"
                                startIcon={<AddIcon />}
                                onClick={() => {
                                    SetOpenModal(true);
                                    setStatus('add');
                                }}
                            >
                                ເພີ່ມຂໍ້ມູນ
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

                {/*** Datatable show*/}
                <Box
                    className='main_tb'
                    sx={{
                        overflowX: 'scroll',
                        maxWidth: '130ch',
                        backgroundColor: 'background.paper',
                        display: `${dataTatleShow}`
                    }}
                >
                    <DataTable
                        title={""}
                        data={loadVal}
                        columns={columns}
                        options={options}
                    />
                </Box>

                {/*** Data empty*/}
                <Nodata
                    loading={loading}
                    val={nodata}
                    mt={15}
                    submessage='ກົດປຸ່ມເພີ່ມຂໍ້ມູນ ເພື່ອເພີ່ມຂໍ້ມູນຜູ້ໃຊ້ງານ'
                    submessage2=''
                />

                {/*** Setting manage restpass, edit role, edit and delete menu */}
                {SettingMenu}

                {/*** Add/Edit Merchant data ***/}
                <MerchantPaymentinfoForm
                    open={openModal}
                    status={status}
                    close={closeModal}
                    editval={editval}
                    loadVal={setLoadVal}
                />

                {/***  Modal popup alert*/}
                <AlertPopup
                    width='400px'
                    props={alertPopup}
                    func={() => {
                        alertPopup.btn.btnAction.func();
                        alertPopup.btn.btnCancel.func();
                    }}
                />

                {/* For view img */}
                <ImgViewer
                    visible={visible}
                    onClose={() => { setVisible(false); }}
                    images={menuImageViewer}
                    attribute={false}
                    onStartSlide
                    zIndex="1000"
                />

            </Box>
        </>
    )
}

export default MerchantPaymentinfo